module.exports = __webpack_public_path__ + "assets/img/thumb_ch2-item-0.8d9e3c6d.jpg";